// ACTION TYPES
const TYPES = {
  OPEN_ESS_INVITE_EMAIL_MODAL: 'OPEN_ESS_INVITE_EMAIL_MODAL',
  CLOSE_ESS_INVITE_EMAIL_MODAL: 'CLOSE_ESS_INVITE_EMAIL_MODAL',
}

// REDUCER
const initialState = {
  isModalOpened: false,
}

export const widgetEssReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.OPEN_ESS_INVITE_EMAIL_MODAL:
      return {
        ...state,
        isModalOpened: true,
      }
    case TYPES.CLOSE_ESS_INVITE_EMAIL_MODAL:
      return {
        ...state,
        isModalOpened: false,
      }
    default:
      return state
  }
}
